'use client'

import React from 'react'
import { LuArrowUpLeft, LuArrowUpRight } from 'react-icons/lu'

import { useLocale } from '@/components/LocaleContext'
import { getLocalizedTranslationData } from '@/utilities/translationsData'

export type ViewProjectsButtonProps = {
  href?: string
  children?: React.ReactNode
  className?: string
}

function ViewProjectsDefaultContent() {
  const { locale, translatedData } = useLocale()
  const label =
    translatedData?.common?.view_projects ??
    getLocalizedTranslationData((locale as AppLocale) ?? 'en').common?.view_projects ??
    'View Projects'
  return (
    <>
      {label}
      {locale == 'ar' ? (
        <LuArrowUpLeft
          size={18}
          aria-hidden
          className="shrink-0 view-projects-btn__arrow max-[480px]:!size-3"
        />
      ) : (
        <LuArrowUpRight
          size={18}
          aria-hidden
          className="shrink-0 view-projects-btn__arrow max-[480px]:!size-3"
        />
      )}
    </>
  )
}

export function ViewProjectsButton({
  href = '/insights',
  children,
  className = '',
}: ViewProjectsButtonProps) {
  const { locale } = useLocale()
  const textCase = locale === 'ar' ? 'normal-case' : 'uppercase'
  return (
    <div className="w-full rtl:text-right rtl:flex">
      <div
        className={`view-projects-btn-wrapper rtl:!text-right inline-flex w-[218px] justify-start max-[480px]:w-[142px] max-[480px]:min-w-0 ${className}`.trim()}
      >
        <a
          href={href}
          className={`view-projects-btn inline-flex w-full items-center justify-center gap-2.5 min-h-[66px] h-[66px] bg-[#E60023] text-white px-[33px] py-[30px] text-xs font-medium ${textCase} tracking-wider focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#E60023] max-[480px]:h-[43px] max-[480px]:min-h-[43px] max-[480px]:w-[142px] max-[480px]:min-w-0 max-[480px]:px-[21.53px] max-[480px]:py-[13.7px] max-[480px]:gap-[6.52px]`.trim()}
        >
          {children != null ? children : <ViewProjectsDefaultContent />}
        </a>
      </div>
    </div>
  )
}
